import { Container, Paper, Stack, Typography } from "@mui/material";
import { Login } from 'Components/AuthV2/Login';
import { useAppDispatch, useAppSelector } from "helpers/hooks";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { resetAuth } from 'store/slices/auth-v2/auth-v2-slice';
import { IApplyJobLogin } from "./ApplyJobModel";

export const ApplyJobLogin = ({ setCurrentJobApplyStep, email, navigatedFrom }: IApplyJobLogin) => {

    const dispatch = useAppDispatch();
    const { checkIfAccountExistsResponse } = useAppSelector((state) => state.auth.auth);

    const handleBackInApplyJobLogin = () => {
        setCurrentJobApplyStep(navigatedFrom);
        dispatch(resetAuth());
    }

    return (<>
        <Container maxWidth='xs'>
            <Paper variant='outlined'>
                <Stack rowGap={3} alignSelf='center' alignItems='center' padding={{ xs: 1, sm: 2, md: 2, lg: 3 }}>
                    <Typography variant="body2">Welcome back, {checkIfAccountExistsResponse?.firstname}!</Typography>
                    <Typography variant="caption">Please login to continue</Typography>
                    <Stack rowGap={3} alignItems='center'>
                        <Login emailAutoFill={email} usedIn="candidate_apply_job" isShowSocialLogin />
                    </Stack>
                    <Stack direction='row' justifyContent='space-between' width='100%' alignItems='center'>
                        <ShButton onClick={handleBackInApplyJobLogin}>Back</ShButton>
                    </Stack>
                </Stack>
            </Paper>
        </Container>
    </>)
}